"use client";

import type { FC, Ref } from "react";
import type { UIAction } from "@huub-web/ui/types/UIAction";
import { useActions } from "@huub-web/ui/hooks/useActions";
import { Tabs, type TabsRecord } from "@huub-web/ui/components/Tabs";

interface ActionTab extends TabsRecord {
  action: UIAction;
}

/**
 * @deprecated 💀
 */
export interface ActionTabsTemplateProps {
  tabs: ActionTab[];
}

/**
 * @deprecated 💀
 */
export const ActionTabsTemplate: FC<
  ActionTabsTemplateProps & { ref?: Ref<HTMLUListElement> }
> = ({ tabs, ref, ...props }) => {
  const { handleAction } = useActions();

  const handleTabClick = (tab: TabsRecord) => {
    if ((tab as ActionTab).action) {
      handleAction((tab as ActionTab).action);
    }
  };

  return (
    <Tabs
      ref={ref}
      tabs={tabs ?? []}
      variant="outlined"
      color="background"
      onTabClick={handleTabClick}
      {...props}
    />
  );
};
